import React, { useEffect, useState, lazy } from 'react';
import { CTAButton } from './CTAButton';
import { ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
const resultImages = ['https://cdn.magicpatterns.com/uploads/eUXr1L2ENfAzbQbbbmot7u/ad3.jpg', 'https://cdn.magicpatterns.com/uploads/7i74A1uN2D5Dy3E6WCpqoi/ChatGPT_Image_29_abr_2026,_07_21_51_p.m..png', 'https://cdn.magicpatterns.com/uploads/7h1qPU2exeCiQA1AgFwB9M/5.jpg', 'https://cdn.magicpatterns.com/uploads/qS5YCMNmBBeqUf22EATP66/ad7.jpg', 'https://cdn.magicpatterns.com/uploads/fs4t5fx5ZfJXFUVgXYYmCu/ad2.jpg'];
const results = [{
  label: 'TIENDA 1',
  amount: '$47.000.000',
  image: 'https://cdn.magicpatterns.com/uploads/8iQb4yV17KvLsVexiE4yF4/TIENDA_1.jpg'
}, {
  label: 'TIENDA 2',
  amount: '$21.000.000',
  image: 'https://cdn.magicpatterns.com/uploads/e5774hAGZz8777oghUPigq/TIENDA_2.jpg'
}, {
  label: 'TIENDA 3',
  amount: '$42.140.000',
  image: 'https://cdn.magicpatterns.com/uploads/ttY5TSkg5grcyCbbsyQbQJ/TIENDA_3.png'
}];
export function RealResultsSection() {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [heroSlide, setHeroSlide] = useState(0);
  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide(prev => (prev + 1) % results.length);
    }, 4000);
    return () => clearInterval(timer);
  }, []);
  useEffect(() => {
    const timer = setInterval(() => {
      setHeroSlide(prev => (prev + 1) % resultImages.length);
    }, 3500);
    return () => clearInterval(timer);
  }, []);
  const scrollToCompra = () => {
    document.getElementById('compra')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  const goPrev = () => setCurrentSlide(prev => (prev - 1 + results.length) % results.length);
  const goNext = () => setCurrentSlide(prev => (prev + 1) % results.length);
  const goHeroPrev = () => setHeroSlide(prev => (prev - 1 + resultImages.length) % resultImages.length);
  const goHeroNext = () => setHeroSlide(prev => (prev + 1) % resultImages.length);
  return <section className="py-8 md:py-12 px-4 bg-[#2E0640] pt-[10px] pb-[10px]" data-id="element-301">
      <div className="max-w-6xl mx-auto" data-id="element-302">
        <div className="text-center mb-12" data-id="element-303">
          <h2 className="md:text-5xl font-black text-white mb-4 pt-[0px] pb-[0px] text-[28px]" data-id="element-304">
            Quiénes somos y por qué podemos enseñarte?
          </h2>

          {/* Static image */}
          <div className="max-w-md mx-auto mb-8" data-id="element-305">
            <div className="overflow-hidden rounded-2xl border-4 border-[#FC9DFF] shadow-xl" data-id="element-306">
              <img src="https://cdn.magicpatterns.com/uploads/jpjQ2WmqW9RXQDsFySuAuF/Historias_Destacadas.png" alt="Brenda y Nasser - Quiénes somos" loading="lazy" className="w-full object-cover" data-id="element-307" />
            </div>
          </div>

          <p className="text-xl max-w-3xl mx-auto text-[#D9D9D9] pt-[0px] pb-[0px] mt-[-20px] mb-[-20px]" data-id="element-308">
            Somos Nasser Khoder y Brenda H. Emprendores +10 años experiencia,
            Infoproductores, MKT, Creadores de Contenido, Marcas Personales y
            grandes comunidades❤️
          </p>

          <h3 className="text-2xl md:text-4xl font-black text-white mt-10 mb-2" data-id="element-309">
            Y podemos enseñarte porque tenemos{' '}
            <span className="underline decoration-4 decoration-yellow-400" data-id="element-310">
              RESULTADOS
            </span>
          </h3>
          <p className="text-lg md:text-xl text-[#D9D9D9] mb-8 pt-[20px] pb-[20px]" data-id="element-311">
            Esto es lo que facturaron nuestras tiendas los últimos 6 meses👇
          </p>
        </div>

        {/* Carousel */}
        <div className="max-w-lg mx-auto mt-[-35px] mb-[-35px]" data-id="element-312">
          <div className="bg-gray-800 rounded-2xl overflow-hidden animate-neon-violet" data-id="element-313">
            {/* Image carousel */}
            <div className="relative" data-id="element-314">
              <div className="overflow-hidden" data-id="element-315">
                <div className="flex transition-transform duration-700 ease-in-out" style={{
                transform: `translateX(-${currentSlide * 100}%)`
              }} data-id="element-316">
                  {results.map((result, index) => <div key={index} className="w-full flex-shrink-0" data-id="element-317">
                      <div className="p-4 text-center" data-id="element-318">
                        <span className="text-sm font-bold text-green-400 tracking-widest" data-id="element-319">
                          {result.label}
                        </span>
                      </div>
                      <div className="px-4" data-id="element-320">
                        <div className="overflow-hidden rounded-lg" style={{
                      height: '280px'
                    }} data-id="element-321">
                          <img src={result.image} alt={`${result.label} - Resultados de ventas`} loading="lazy" className="w-full h-full object-cover object-top" data-id="element-322" />
                        </div>
                      </div>
                    </div>)}
                </div>
              </div>

              {/* Navigation arrows */}
              <button onClick={goPrev} className="absolute left-2 top-1/2 -translate-y-1/2 bg-black/50 hover:bg-black/70 text-white rounded-full p-2 transition-colors z-10" data-id="element-323">
                <ChevronLeftIcon className="w-5 h-5" data-id="element-324" />
              </button>
              <button onClick={goNext} className="absolute right-2 top-1/2 -translate-y-1/2 bg-black/50 hover:bg-black/70 text-white rounded-full p-2 transition-colors z-10" data-id="element-325">
                <ChevronRightIcon className="w-5 h-5" data-id="element-326" />
              </button>
            </div>

            {/* Footer - shows current slide's data */}
            <div className="p-6 text-center" data-id="element-327">
              <p className="text-3xl md:text-4xl font-black text-green-400 mb-1 transition-all duration-500" data-id="element-328">
                {results[currentSlide].amount}
              </p>
              <p className="text-gray-400 font-semibold text-sm" data-id="element-329">
                PESOS ARGENTINOS EN VENTAS
              </p>
            </div>
          </div>

          {/* Dots */}
          <div className="flex justify-center gap-2 mt-4" data-id="element-330">
            {results.map((_, index) => <button key={index} onClick={() => setCurrentSlide(index)} className={`w-2.5 h-2.5 rounded-full transition-all ${currentSlide === index ? 'bg-[#FC9DFF] scale-125' : 'bg-gray-500 hover:bg-gray-400'}`} data-id="element-331" />)}
          </div>
        </div>

        <div className="text-center pt-[10px] pb-[10px]" data-id="element-332">
          <div className="inline-block px-8 py-3 rounded-full font-black text-[#FFFFFF] bg-[#9C16A3] animate-neon-violet text-[19px] mt-[60px] mb-[60px] pt-[12px] pb-[12px]" data-id="element-333">
            Si aplicas, en semanas podes estar generando MÍNIMO $1.500 - $3.000
            usd💰
          </div>
        </div>
      </div>
    </section>;
}